import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../controllers/ap_courses/ap_courses";
import { fetchIpAddress } from "../../controllers/API";

import LoadingEffect from "../../components/Loading/LoadingEffect";
import ReactQuill from "react-quill";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [DESCRIPTION, setDescription] = useState(ADDEDITDATA?.template || '');
  const [file, setFile] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };
  

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        type,
        subject,
        template
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("editId", _id);
      }
      form.append("subject", subject);
      form.append("type", type);
      form.append("template", DESCRIPTION);

      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      console.log("isValidate", isValidate)
      if (isValidate) {
        const rawData = {
          editId: _id,
          subject: subject,
          type:type,
          template: DESCRIPTION
        }
        const options = {
          // url: `email-templates/addeditdata/${_id?_id:':editId'}`,
          url: `email-templates/addeditdata`,
          // postData: form,
          postData: rawData,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          setDescription();
          navigate("/email-templates");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("subject") || form.get("subject") === "undefined" || form.get("subject") === null) {
      notification.error({
        message: "Validation Error",
        description: "Subject is required",
      });
      return false;
    }
    if (!form.get("template") || form.get("template") === "undefined" || form.get("template") === null) {
      notification.error({
        message: "Validation Error",
        description: "Template is required",
      });
      return false;
    }
    return true;
  };




  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } AP Course`;
  }, [ADDEDITDATA]);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Email Templates
            </h5>
          </div>
          <Link to="/email-templates">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <label for="type" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span>Mail Type</label>
                    <select className="form-control categories_select_tg_enter_product" name='type' id='type' onChange={handleChange}>
                      <option value="">Select email type</option>
                      <option value='Registration' selected={ADDEDITDATA?.type === 'Registration' ? true : false}>Registration</option>
                      <option value='Contact' selected={ADDEDITDATA?.type === 'Contact' ? true : false}>Contact</option>
                      <option value='Job-Application' selected={ADDEDITDATA?.type === 'Job-Application' ? true : false}>Job-Application</option>
                    </select>
                    {error.type ? (<p style={{ color: "red" }}> {error.type} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="subject"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Subject :{" "}
                    </label>
                    <input
                      title="Enter subject"
                      placeholder="Enter subject"
                      type="text"
                      name="subject"
                      className="form-control store_input_field"
                      id="subject"
                      value={ADDEDITDATA?.subject}
                      onChange={handleChange}
                    />
                    {error.subject ? (
                      <p style={{ color: "red" }}>
                        {error.subject}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                 <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <label
                            for="template"
                            className="categories_open_popup_label_name all_lebel_margin_top_main_div"
                          >
                            Message{" "}
                          </label>
                        </div>
                        <div className="term_and_condation_react_quilllll">
                          <ReactQuill
                            theme="snow"
                            modules={{
                              toolbar: [
                                [{ header: [1, 2, 3, 4, 5, false] }],
                                [
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strike",
                                  "blockquote",
                                ],
                                [
                                  { list: "ordered" },
                                  { list: "bullet" },
                                  { indent: "-1" },
                                  { indent: "+1" },
                                ],
                                ["link", "image"],
                                ["clean"],
                              ],
                            }}
                            formats={[
                              "header",
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                              "list",
                              "bullet",
                              "indent",
                              "link",
                              "image",
                            ]}
                            value={DESCRIPTION || ""}
                            onChange={setDescription}
                          />
                        </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
